import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_TARIFCOND_SCHEMA_LITERAL = {
    title: 'Schéma F_TARIFCOND',
    description: 'F_TARIFCOND',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        TC_REFCF: { type: 'string' },
        TC_PRIX: { type: 'number' },
        CO_NO: { type: 'number' },
        EC_ENUMERE: { type: 'string' },
        CO_REF: { type: 'string' },
        EC_QUANTITE: { type: 'number' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'TC_REFCF', 'TC_PRIX', 'CO_NO' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_TARIFCOND_SCHEMA_LITERAL);
export type RxFTarifCondDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_TARIFCOND_SCHEMA: RxJsonSchema<RxFTarifCondDocumentType> = F_TARIFCOND_SCHEMA_LITERAL;
